// extracted by mini-css-extract-plugin
export default {"wrap_1000w":"index_wrap_1000w_dGgae clearfix","list":"index_list_vJ83R"};